export const MIN_TITLE = 1;
export const MAX_TITLE = 200;
export const MIN_DESCRIPTION = 1;
export const MAX_DESCRIPTION = 400;
export const MAX_CATEGORY = 50;

export const MAX_EXPENSE_PRICE = 999_999_999.99;
